import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./AnnouncementDetail.css";
import Navbar from "./Navbar";

const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

// Detail view opened when a user taps an announcement notification with no
// link (or from the in-app list). Fetches the announcement by id and shows a
// loading state, a proper error/empty state (deleted / bad id), or the full
// content (title, body, sender, timestamp, image, and a tappable link).
function AnnouncementDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${BASE_URL}/api/announcements/${id}`);
        if (!res.ok) {
          if (!active) return;
          setError(
            res.status === 404
              ? "This announcement is no longer available."
              : "Could not load this announcement. Please try again."
          );
          return;
        }
        const data = await res.json();
        if (!active) return;
        setAnnouncement(data);
      } catch (err) {
        if (active) setError("Could not load this announcement. Please try again.");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [id]);

  const senderName =
    (announcement && announcement.sender && announcement.sender.name) || "Admin";

  return (
    <div className="ann-root">
      <Navbar />
      <div className="ann-container">
        <button className="ann-back" onClick={() => navigate("/notify")}>
          ← Notifications
        </button>

        {loading ? (
          <div className="ann-state">
            <div className="ann-spinner" />
            <p>Loading announcement…</p>
          </div>
        ) : error ? (
          <div className="ann-state">
            <div className="ann-state-icon">📭</div>
            <p>{error}</p>
          </div>
        ) : announcement ? (
          <div className="ann-card">
            <div className="ann-badge">📢 Announcement</div>
            {announcement.title && (
              <h1 className="ann-title">{announcement.title}</h1>
            )}
            <div className="ann-meta">
              <span className="ann-sender">{senderName}</span>
              <span className="ann-dot">·</span>
              <span className="ann-time">
                {new Date(announcement.createdAt).toLocaleString()}
              </span>
            </div>
            {announcement.image && (
              <img className="ann-image" src={announcement.image} alt="" />
            )}
            <p className="ann-body">{announcement.body}</p>
            {announcement.link && (
              <a
                className="ann-link"
                href={announcement.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                🔗 Open link
              </a>
            )}
          </div>
        ) : (
          <div className="ann-state">
            <div className="ann-state-icon">📭</div>
            <p>This announcement is no longer available.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AnnouncementDetail;
